import type { Theme as ExtendedTheme } from '@mui/material/styles';

// Print and PDF export code needs serialized light-scheme colors; CSS variable
// tokens cannot be resolved by the export pipeline.
const getLightThemePalette = (theme: ExtendedTheme) =>
    theme.colorSchemes?.light?.palette;

export const getPrintTextPrimaryColor = (theme: ExtendedTheme) =>
    getLightThemePalette(theme)?.text?.primary ?? theme.palette.text.primary;

export const getPrintTextSecondaryColor = (theme: ExtendedTheme) =>
    getLightThemePalette(theme)?.text?.secondary ??
    theme.palette.text.secondary;

export const getPrintDividerColor = (theme: ExtendedTheme) =>
    getLightThemePalette(theme)?.divider ?? theme.palette.divider;

export const getPrintLinkColor = (theme: ExtendedTheme) =>
    getLightThemePalette(theme)?.link?.default ?? theme.palette.primary.main;

export interface ArticlePrintBrandingTokens {
    textColor: string;
    linkColor: string;
    headerLogoWidth: string;
    headerLogoMarginBottom: string;
    headerLogoSrc: string;
    pageLogoSrc: string;
    pageLogoSize: string;
    pageLogoOffset: string;
}

export const getArticlePrintBrandingTokens = (
    theme: ExtendedTheme
): ArticlePrintBrandingTokens => ({
    textColor: getPrintTextPrimaryColor(theme),
    linkColor: getPrintLinkColor(theme),
    headerLogoWidth: theme.spacing(12.5),
    headerLogoMarginBottom: theme.spacing(2),
    headerLogoSrc: '/insights/images/marex-dark-logo.png',
    pageLogoSrc: '/insights/images/marex-dark-logo-vertical.png',
    pageLogoSize: theme.spacing(5),
    pageLogoOffset: theme.spacing(1),
});
